// extracted by mini-css-extract-plugin
module.exports =  {"exam-activity":"Exam-uztq__exam-activity","blur-overlay":"Exam-SUPl__blur-overlay","fullscreen-overlay":"Exam-grZO__fullscreen-overlay","pagination":"Exam-Ghy4__pagination"};